export const getStatusStyle = status => {
  switch (status) {
    case 'On going':
      return 'bg-yellow-100 text-yellow-800';
    case 'Email opened':
      return 'bg-green-100 text-green-800';
    case 'Hot':
      return 'bg-red-100 text-red-800';
    case 'Cold':
      return 'bg-yellow-100 text-yellow-800';
    case 'Fallido':
      return 'bg-red-100 text-red-800';
    case 'Ilocalizable':
      return 'bg-red-100 text-red-800';
    case 'Sin datos de contacto':
      return 'bg-red-100 text-red-800';
    case 'Cancelled':
      return 'bg-red-100 text-red-800';
    case 'Dispute':
      return 'bg-red-100 text-red-800';
    case 'Burofax Enviado':
      return 'bg-yellow-100 text-yellow-800';
    case 'Burofax con resultado negativo':
      return 'bg-red-100 text-red-800';
    case 'Burofax con resultado positivo':
      return 'bg-green-100 text-green-800';
    case 'Demanda pendiente':
      return 'bg-yellow-100 text-yellow-800';
    case 'Demanda preparada':
      return 'bg-yellow-100 text-yellow-800';
    case 'Demanda presentada':
      return 'bg-yellow-100 text-yellow-800';
    case 'Demanda Admitida':
      return 'bg-green-100 text-green-800';
    case 'Demanda No Admitida':
      return 'bg-red-100 text-red-800';
    case 'Oposición del Deudor':
      return 'bg-red-100 text-red-800';
    case 'Pendiente Requerimiento':
      return 'bg-yellow-100 text-yellow-800';
    case 'Requerimiento Judicial Positivo':
      return 'bg-green-100 text-green-800';
    case 'Pendiente Ejecucion':
      return 'bg-red-100 text-red-800';
    case 'Sentencia Estimatoria':
      return 'bg-green-100 text-green-800';
    case 'Sentencia Desestimatoria':
      return 'bg-red-100 text-red-800';
    case 'Sentencia Parcial':
      return 'bg-yellow-100 text-yellow-800';
    case 'Cobrado':
      return 'bg-green-100 text-green-800';
    case 'Cobrado Judicialmente':
      return 'bg-green-100 text-green-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
